import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Fragment as _Fragment, createCommentVNode as _createCommentVNode, renderList as _renderList, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = { class: "flex cleopatra flex-col w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "container flex gap-2 justify-between max-w-5xl mx-auto overflow-x-auto p-5 pb-3 xl:flex-row" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h1", { class: "h1" }, "Order Details")
  ])
], -1)
const _hoisted_4 = { class: "container flex flex-col gap-2 justify-between max-w-5xl mx-auto overflow-x-auto px-5 py-3 xl:flex-row" }
const _hoisted_5 = { class: "button-back cursor-pointer" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  width: "6",
  height: "10",
  viewBox: "0 0 6 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "5",
    y1: "0.707107",
    x2: "0.707106",
    y2: "5",
    stroke: "#222B45",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "0.707107",
    y1: "5",
    x2: "5",
    y2: "9.29289",
    stroke: "#222B45",
    "stroke-linecap": "round"
  })
], -1)
const _hoisted_7 = {
  key: 0,
  class: "container flex flex-col gap-2 max-w-5xl mx-auto overflow-x-auto p-5"
}
const _hoisted_8 = { class: "box-details flex flex-col gap-4" }
const _hoisted_9 = { class: "flex flex-col gap-4 w-full md:flex-row" }
const _hoisted_10 = { class: "flex flex-col gap-2 w-full" }
const _hoisted_11 = { class: "h2" }
const _hoisted_12 = { class: "text" }
const _hoisted_13 = { class: "text" }
const _hoisted_14 = { class: "text-title" }
const _hoisted_15 = { class: "flex flex-col gap-2 w-full" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "text-title" }, "Type", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "text-title" }, "Delivery Time", -1)
const _hoisted_18 = { class: "text" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "text-title" }, "Pickup Time", -1)
const _hoisted_20 = { class: "text" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "text-title" }, "Table", -1)
const _hoisted_22 = { class: "text" }
const _hoisted_23 = { class: "flex flex-col gap-2 w-full" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "text-title" }, "Customer", -1)
const _hoisted_25 = { class: "text" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "text" }
const _hoisted_28 = { class: "text" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "button-nav-admin button-view-map" }, "View map", -1)
const _hoisted_30 = { class: "flex flex-wrap gap-2 w-full 2xl:flex-row" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "text-title" }, "Comment:", -1)
const _hoisted_32 = { class: "text" }
const _hoisted_33 = /*#__PURE__*/_createStaticVNode("<div class=\"border-t flex flex-row pt-4 w-full\"><div class=\"flex w-32 md:w-48\"><p class=\"text-title\">Product</p></div><div class=\"flex flex-1\"><p class=\"text-title\">Option</p></div><div class=\"flex flex-col items-end\"><p class=\"text-title\">Price</p></div></div>", 1)
const _hoisted_34 = { class: "flex gap-2 w-32 md:w-48" }
const _hoisted_35 = { class: "button-order-count" }
const _hoisted_36 = { class: "text-title" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "text-small" }, "SKU: DO8273", -1)
const _hoisted_38 = { class: "flex flex-1 flex-col" }
const _hoisted_39 = { class: "text" }
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = { class: "flex flex-col items-end" }
const _hoisted_42 = { class: "text" }
const _hoisted_43 = { class: "border-t flex flex-col gap-2 pt-4" }
const _hoisted_44 = { class: "flex flex-row gap-2 justify-end w-32" }
const _hoisted_45 = { class: "text-title" }
const _hoisted_46 = { class: "flex flex-col gap-2 w-24" }
const _hoisted_47 = { class: "flex justify-end" }
const _hoisted_48 = { class: "box-details flex flex-col gap-4" }
const _hoisted_49 = { class: "h-96 pg-empty-placeholder flex flex-col" }
const _hoisted_50 = { class: "flex gap-4 items-center justify-between pt-5" }
const _hoisted_51 = { class: "flex flex-col w-1/2" }
const _hoisted_52 = { class: "flex gap-2" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Cook:", -1)
const _hoisted_54 = { class: "text-title" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Assign Cook")
], -1)
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = { class: "flex gap-4 items-center justify-between" }
const _hoisted_58 = { class: "flex flex-col w-1/2" }
const _hoisted_59 = { class: "flex gap-2" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Driver:", -1)
const _hoisted_61 = { class: "text-title" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Assign Driver")
], -1)
const _hoisted_63 = [
  _hoisted_62
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StepperView = _resolveComponent("StepperView")!
  const _component_CookView = _resolveComponent("CookView")!
  const _component_DriverView = _resolveComponent("DriverView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/order')))
            }, "Back")
          ])
        ]),
        (_ctx.Order.Store)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.Order.Store ? _ctx.Order.Store.Name : null), 1),
                    _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.Order.Store
                    ? _ctx.helpers.getAllAddress(_ctx.Order.Store.Address)
                    : null), 1),
                    _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.helpers.formatDate(new Date(_ctx.Order.PlacedAt), "d.M.yyyy")) + "• " + _toDisplayString(_ctx.helpers.formatDate(new Date(_ctx.Order.PlacedAt), "HH:mm")) + "• ", 1),
                    _createElementVNode("p", _hoisted_14, "Order ID: " + _toDisplayString(_ctx.Order.UniqueId), 1)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", null, [
                      _hoisted_16,
                      _createElementVNode("p", {
                        class: "text",
                        style: _normalizeStyle(`color: ${_ctx.helpers.getDeliveryColor(
                    _ctx.Order.DeliveryType
                  )}`)
                      }, _toDisplayString(_ctx.Order.DeliveryType.toUpperCase()) + "  ", 5)
                    ]),
                    _createElementVNode("div", null, [
                      (_ctx.Order.DeliveryType === 'delivery')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_17,
                            _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.Order.DeliveryTime
                        ? _ctx.helpers.formatDate(
                            new Date(_ctx.Order.DeliveryTime),
                            "d.M.yyyy • kk:mm"
                          )
                        : _ctx.$t("AS SOON AS POSSIBLE")), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (_ctx.Order.DeliveryType === 'pickup')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_19,
                            _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.Order.DeliveryTime
                        ? _ctx.helpers.formatDate(
                            new Date(_ctx.Order.DeliveryTime),
                            "d.M.yyyy • kk:mm"
                          )
                        : _ctx.$t("AS SOON AS POSSIBLE")), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (_ctx.Order.DeliveryType === 'in-store')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _hoisted_21,
                            _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.Order.Table), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", null, [
                      _hoisted_24,
                      _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.Order.Customer.FirstName + " " + _ctx.Order.Customer.LastName), 1),
                      (_ctx.Order.DeliveryType === 'delivery')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.Street), 1),
                            _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.Address), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_29
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.Order.Comment), 1)
                ]),
                _hoisted_33,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Order.Items, ({ Item, OrderItemOption, OrderItemExtras }, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "flex flex-row flex-wrap w-full",
                    key: idx
                  }, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("span", _hoisted_35, _toDisplayString(OrderItemOption.Quantity) + "x", 1),
                      _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_36, _toDisplayString(Item.Name), 1),
                        _hoisted_37
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("span", _hoisted_39, _toDisplayString(`${_ctx.getItemOption(
                  Item.ItemOptions,
                  OrderItemOption
                )}(${_ctx.helpers.toCurrency(OrderItemOption.Price)})`), 1),
                      _createElementVNode("span", {
                        class: "hidden text md:flex",
                        innerHTML: _ctx.getItemExtras(Item.ItemExtras, OrderItemExtras)
                      }, null, 8, _hoisted_40)
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, _toDisplayString(`${OrderItemOption.Quantity}x${" "}${_ctx.helpers.toCurrency(
                    _ctx.getTotal(OrderItemOption.Price, OrderItemExtras)
                  )}`), 1)
                    ])
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_43, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries({
                Subtotal: _ctx.Order.Total,
                Discount: _ctx.Order.DiscountedAmount,
                Delivery: _ctx.Order.DeliveryCost || 0,
                Total: _ctx.Order.DiscountedTotal,
              }), ([key, val], idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "flex flex-row justify-end w-full",
                      key: idx
                    }, [
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("p", _hoisted_45, _toDisplayString(key), 1)
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("p", {
                            class: _normalizeClass({
                      text: `${key == 'Subtotal'}${key == 'Delivery'}`,
                      'text-order-coupon': key == 'Discount',
                      'text text-order-total': key === 'Total',
                    })
                          }, _toDisplayString(`${key === "Discount" ? "-" : ""}${_ctx.helpers.toCurrency(
                        val
                      )}`), 3)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createVNode(_component_StepperView, {
                    "circle-tabs": "",
                    "custom-tabs": [_ctx.customTabs, _ctx.result],
                    onUpdateTime: _ctx.getDetail
                  }, null, 8, ["custom-tabs", "onUpdateTime"])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _hoisted_53,
                      _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.Order.Cook
                    ? `${_ctx.Order.Cook.FirstName}${_ctx.Order.Cook.LastName}`
                    : _ctx.$t("No assignment")), 1)
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "button-assign w-52",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.assignCook = !_ctx.assignCook))
                  }, _hoisted_56)
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      _hoisted_60,
                      _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.Order.Driver
                    ? `${_ctx.Order.Driver.FirstName}${_ctx.Order.Driver.LastName}`
                    : _ctx.$t("No assignment")), 1)
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "button-assign w-52",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.assignDriver = !_ctx.assignDriver))
                  }, _hoisted_63)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.assignCook)
      ? (_openBlock(), _createBlock(_component_CookView, {
          key: 0,
          onCloseCook: _ctx.closeCook,
          items: _ctx.Users,
          "item-text": "FirstName,LastName",
          "item-value": "Id",
          placeholder: 'cook',
          modelValue: _ctx.Order.CookId,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.Order.CookId) = $event)),
          cookId: _ctx.Order.CookId,
          storeId: _ctx.Order.Store.Id,
          rules: "required"
        }, null, 8, ["onCloseCook", "items", "modelValue", "cookId", "storeId"]))
      : _createCommentVNode("", true),
    (_ctx.assignDriver)
      ? (_openBlock(), _createBlock(_component_DriverView, {
          key: 1,
          onCloseDriver: _ctx.closeDriver,
          items: _ctx.Users,
          "item-text": "FirstName,LastName",
          "item-value": "Id",
          placeholder: 'Driver',
          modelValue: _ctx.Order.DriverId,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.Order.DriverId) = $event)),
          driverId: _ctx.Order.DriverId,
          storeId: _ctx.Order.Store.Id,
          rules: "required"
        }, null, 8, ["onCloseDriver", "items", "modelValue", "driverId", "storeId"]))
      : _createCommentVNode("", true)
  ], 64))
}